import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, InteriorComponent, OuterMeasurementsComponent, HideInSeeThroughSystemComponent, AssemblyInstructionsComponent } from '@inter-ikea-storageone/range';
export const elvarliComponentResolver = (_coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.ELVARLI_DRAWER,
        ProductType.ELVARLI_SECTION,
        ProductType.ELVARLI_SHELF_BAMBOO,
        ProductType.ELVARLI_SHELF_WHITE,
        ProductType.ELVARLI_SHOE_SHELF
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.ELVARLI_DRAWER,
        ProductType.ELVARLI_SECTION,
        ProductType.ELVARLI_SHELF_BAMBOO,
        ProductType.ELVARLI_SHELF_WHITE,
        ProductType.ELVARLI_SHOE_SHELF
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([ProductType.ELVARLI_SECTION]);
    const hideInSeeThroughEntitySystem = isOfType([ProductType.ELVARLI_SECTION]);
    const isInterior = isOfType([
        ProductType.ELVARLI_DRAWER,
        ProductType.ELVARLI_SHELF_BAMBOO,
        ProductType.ELVARLI_SHELF_WHITE,
        ProductType.ELVARLI_SHOE_SHELF
    ]);
    const shouldHaveAssemblyInstructions = isOfType([ProductType.ELVARLI_SECTION]);
    const componentBuilder = {
        build: (entity) => {
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=elvarliComponentResolver.js.map